import { z } from 'zod';
export const ValidationErrorResponse = z.object({
    message: z.literal('Invalid request'),
    error: z.literal('Invalid request'),
    location: z.enum(['params', 'query', 'body']),
    issues: z.array(z.object({
        code: z.string(),
        path: z.string(),
    })),
});
export const MessageErrorResponse = z.object({ message: z.string() });
export const HttpErrorResponse = z.union([
    ValidationErrorResponse,
    MessageErrorResponse,
]);
